/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import GoalstemplatesidGoalTemplateEscalation from './GoalstemplatesidGoalTemplateEscalation';
import GoalstemplatesidGoalTemplateReminders from './GoalstemplatesidGoalTemplateReminders';

/**
 * The GoalstemplatesGoalTemplate model module.
 * @module model/GoalstemplatesGoalTemplate
 * @version v0.3
 */
export default class GoalstemplatesGoalTemplate {
  /**
   * Constructs a new <code>GoalstemplatesGoalTemplate</code>.
   * @alias module:model/GoalstemplatesGoalTemplate
   * @class
   * @param name {String} Name of the goal template
   * @param description {String} Description of the goal template
   */
  constructor(name, description) {
    this.name = name;
    this.description = description;
  }

  /**
   * Constructs a <code>GoalstemplatesGoalTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalstemplatesGoalTemplate} obj Optional instance to populate.
   * @return {module:model/GoalstemplatesGoalTemplate} The populated <code>GoalstemplatesGoalTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalstemplatesGoalTemplate();
      if (data.hasOwnProperty('target_template_ids'))
        obj.targetTemplateIds = ApiClient.convertToType(data['target_template_ids'], ['String']);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('duration'))
        obj.duration = ApiClient.convertToType(data['duration'], 'Number');
      if (data.hasOwnProperty('cron_expression'))
        obj.cronExpression = ApiClient.convertToType(data['cron_expression'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('rich_description'))
        obj.richDescription = ApiClient.convertToType(data['rich_description'], 'String');
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
      if (data.hasOwnProperty('cms_entry_id'))
        obj.cmsEntryId = ApiClient.convertToType(data['cms_entry_id'], 'String');
      if (data.hasOwnProperty('reminders'))
        obj.reminders = ApiClient.convertToType(data['reminders'], [GoalstemplatesidGoalTemplateReminders]);
      if (data.hasOwnProperty('send_before_activation'))
        obj.sendBeforeActivation = ApiClient.convertToType(data['send_before_activation'], 'Boolean');
      if (data.hasOwnProperty('reminder_message'))
        obj.reminderMessage = ApiClient.convertToType(data['reminder_message'], 'String');
      if (data.hasOwnProperty('escalation'))
        obj.escalation = GoalstemplatesidGoalTemplateEscalation.constructFromObject(data['escalation']);
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} targetTemplateIds
 */
GoalstemplatesGoalTemplate.prototype.targetTemplateIds = undefined;

/**
 * Name of the goal template
 * @member {String} name
 */
GoalstemplatesGoalTemplate.prototype.name = undefined;

/**
 * Description of the goal template
 * @member {String} description
 */
GoalstemplatesGoalTemplate.prototype.description = undefined;

/**
 * Number of days the goal should take to achieve
 * @member {Number} duration
 */
GoalstemplatesGoalTemplate.prototype.duration = undefined;

/**
 * Cron expression defining the goal's frequency of recurrence
 * @member {String} cronExpression
 */
GoalstemplatesGoalTemplate.prototype.cronExpression = undefined;

/**
 * External ID for this goal
 * @member {String} externalId
 */
GoalstemplatesGoalTemplate.prototype.externalId = undefined;

/**
 * Rich text HTML description of the goal template
 * @member {String} richDescription
 */
GoalstemplatesGoalTemplate.prototype.richDescription = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
GoalstemplatesGoalTemplate.prototype.tagList = undefined;

/**
 * Add a link to your CMS content
 * @member {String} cmsEntryId
 */
GoalstemplatesGoalTemplate.prototype.cmsEntryId = undefined;

/**
 * Date-relative reminders for both SMS and email. Replaces the full schedule when supplied; an empty array clears it and omitting it preserves it. Duplicate days/relation/anchor combinations are invalid.
 * @member {Array.<module:model/GoalstemplatesidGoalTemplateReminders>} reminders
 */
GoalstemplatesGoalTemplate.prototype.reminders = undefined;

/**
 * Whether reminders and escalation are allowed before activation. Defaults to false.
 * @member {Boolean} sendBeforeActivation
 */
GoalstemplatesGoalTemplate.prototype.sendBeforeActivation = undefined;

/**
 * Plain text patient question, trimmed, maximum 1600 characters. Required when reminders exist.
 * @member {String} reminderMessage
 */
GoalstemplatesGoalTemplate.prototype.reminderMessage = undefined;

/**
 * @member {module:model/GoalstemplatesidGoalTemplateEscalation} escalation
 */
GoalstemplatesGoalTemplate.prototype.escalation = undefined;
